import DeliveryTables from '@/components/orders/tables/delivery-tables/DeliveryTables';
import { DeliveryTableDataProvider } from '@/context/orders/DeliveryTableFilteredData';
import { ListOrdersView } from '@/hooks/orders/useListOrders';
import { DELIVERY_OPTION, DELIVERY_OPTIONS } from '@montugroup/circuit-shared';
import DeliveryTable from '../DeliveryTable';

function PendingCollectionTable() {
  return (
    <DeliveryTableDataProvider view={ListOrdersView.PendingCollection}>
      <DeliveryTables>
        <DeliveryTable
          title="Click & collect pending collection"
          tooltipProps={{
            title: 'Pending collection orders',
            body: 'These are orders that have been dispensed and are ready for your customer to pick up. Once they collect their medication you can mark the order as collected to keep your queue clear and communications will send out to your customer.',
          }}
          shippingType={DELIVERY_OPTIONS[DELIVERY_OPTION.ClickAndCollect].name}
        />
      </DeliveryTables>
    </DeliveryTableDataProvider>
  );
}

export default PendingCollectionTable;
